/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : MenuItems
Description : Componente que contiene la información de los botones de la barra de navegación de la aplicación
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se defienen los botones de la barra de navegación.
================================================================================ */

export const MenuItems3 = [
    {
        label: 'Centro de costo',
        url: '/AccountantCost_center',
        index: 0,
    },
    {
        label: 'Plan de cuentas contables',
        url: '/AccountantAccount_Plan',
        index: 1,
    },
    {
        label: 'Terceros',
        url: '/AccountantThird',
        index: 2,
    }
]